const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect'

/**
 * 同一オリジン内の相対パスのみを許可する（オープンリダイレクト対策）。
 * - 許可: '/' 始まり かつ '//' / '/\' で始まらないパス（例: '/sp/berth-management?x=1'）
 * - 拒否: '//evil.com'（プロトコル相対）, 'https://...', 'javascript:', null, '' など
 */
export const isSafeInternalPath = (path: string | null | undefined): path is string => {
  if (!path) return false
  return /^\/(?!\/|\\)/.test(path)
}

/**
 * ログイン後の戻り先（path + search）を保存する。
 * 未認証で保護ページにアクセスした際に呼ぶ。安全な相対パス以外は保存しない。
 */
export const setPostLoginRedirect = (path: string): void => {
  if (!isSafeInternalPath(path)) return
  try {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path)
  } catch {
    // sessionStorage が使えない環境では戻り先保持を諦める（ログイン自体は継続）
  }
}

/**
 * 保存済みの戻り先を取得し、同時に破棄する（消費）。
 * 保存値が無い・不正な場合は null を返す。残留による次回ログインへの誤遷移を防ぐため、
 * 取得時に必ず削除する。
 */
export const consumePostLoginRedirect = (): string | null => {
  try {
    const path = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
    return isSafeInternalPath(path) ? path : null
  } catch {
    return null
  }
}

/**
 * 保存済みの戻り先を破棄する。
 * ログアウト時に呼び、認証済み画面から logout 経由で /login へ遷移した際に
 * 直前の画面が戻り先として残留しないようにする。
 */
export const clearPostLoginRedirect = (): void => {
  try {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
  } catch {
    // sessionStorage が使えない環境では何もしない
  }
}
